export default "__VITE_ASSET__deec9077__"